import axios from '@/plugins/axios'
export const area = () => {
  let areaData
  if (!areaData) {
    (function () {
      axios.get('/shared-api/divisionCode', { disableInterceptors: true }).then(res => {
        areaData = res.data || {}
      })
    }())
  }
  return () => areaData
}



// WEBPACK FOOTER //
// ./src/utils/getAreaData.js